import React, { useState, useContext } from 'react';
import { View, Text, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faXmark, faDollarSign
} from '@fortawesome/free-solid-svg-icons';

import { currency } from 'app/src/utils/stringHelpers';

import Counter from './Counter';
import { UPDATE_FEE_ESTIMATE } from './queries';
import AuthContext from '../../../contexts/AuthContext';

const Container = styled(View)`
  flex-direction: row;
  width: 20%;
  justify-content: space-around;
`;

const EstimateFunctions = ({ feeEstimate, refetch, feeRefetch }) => {
  const { user } = useContext(AuthContext);
  const [showModal, setShowModal] = useState();
  const [updateFeeEstimate] = useMutation(UPDATE_FEE_ESTIMATE, {
    onCompleted: () => {
      if(refetch) refetch();
      if(feeRefetch) feeRefetch();
      setShowModal(false)
    }
  });

  const stockNumber = feeEstimate.asset.stockNumber;
  const amount = feeEstimate.amount;

  const acceptConfirm =
    `Click OK to ACCEPT this ${feeEstimate.type} fee of ${currency(amount)} for ${stockNumber}`;

  const accept = () => {
    if (confirm(acceptConfirm)) {
console.log('user', user)
      updateFeeEstimate({
        variables: {
          id: parseInt(feeEstimate.id),
          status: 'Accepted',
          acceptedByType: 'SellerUser',
          acceptedById: user?.id,
          acceptMethod: 'Seller Portal',
        }
      });
    }
  };

  const declineConfirm =
    `Click OK to DECLINE this ${feeEstimate.type} fee of ${currency(amount)} for ${stockNumber}`;

  const decline = () => {
    if (confirm(declineConfirm)) {
      updateFeeEstimate({
        variables: {
          id: parseInt(feeEstimate.id),
          status: 'Rejected'
        }
      });
    }
  };

  return (
    <>
      <Container style={{width: '100%'}}>
        <Pressable onPress={accept}>
          <FontAwesomeIcon
            icon={faCheck}
            color="green"
            size="lg"
            title="Accept"
          />
        </Pressable>
        <Pressable onPress={decline}>
          <FontAwesomeIcon
            icon={faXmark}
            color="red"
            size="lg"
            title="Decline"
          />
        </Pressable>
        <Pressable onPress={() => setShowModal(true)}>
          <FontAwesomeIcon
            icon={faDollarSign}
            color="black"
            size="lg"
            title="Counter"
          />
        </Pressable>
      </Container>
      {showModal && (
        <Counter
          feeEstimate={feeEstimate}
          setShowModal={setShowModal}
          updateFeeEstimate={updateFeeEstimate}
        />
      )}
    </>
  );
};

export default EstimateFunctions;
